var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.16649 1.83015C0.00934692 1.24158 0.613918 0.738718 1.1642 1.001L13.4488 6.85757C13.9911 7.11586 13.9911 7.88843 13.4488 8.14672L1.16363 14.0039C0.613347 14.2656 0.00877553 13.7627 0.165918 13.1741L1.68477 7.50215L0.16649 1.83015ZM2.45677 7.93072L1.07506 13.0964L12.8093 7.50215L1.07506 1.90786L2.45677 7.07357H8.8562C8.96987 7.07357 9.07887 7.11873 9.15925 7.1991C9.23962 7.27947 9.28477 7.38848 9.28477 7.50215C9.28477 7.61581 9.23962 7.72482 9.15925 7.80519C9.07887 7.88556 8.96987 7.93072 8.8562 7.93072H2.45677Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGray);
export default __webpack_public_path__ + "static/media/sendGray.660fcbaa92d3e06d7e65acfcea55e491.svg";
export { ForwardRef as ReactComponent };